export default function (ListParcel, filters, filtersConfig) {
    return class ItemsSearchParcel extends ListParcel {
        constructor(keyword = '', page) {

            const search = keyword.trim() || null;

            const orders = [{
                key: 'id',
                isAsc: false
            }];

            const limit = 40;

            const offset = page * limit;

            super({search, filters, filtersConfig, orders, limit, offset});
        }
    }
}
